/* ============================================================
   BoticaT Theme — JavaScript (Light Theme)
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── THEME: toggle claro/oscuro ────────────────────────────
  document.querySelectorAll('.bt-theme-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const cur = document.documentElement.getAttribute('data-bt-theme') === 'dark' ? 'dark' : 'light';
      const next = cur === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-bt-theme', next);
      try { localStorage.setItem('bt-theme', next); } catch (e) {}
    });
  });

  // ── NAVBAR: scroll state ──────────────────────────────────
  const header = document.getElementById('bt-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── NAVBAR: mobile burger ─────────────────────────────────
  const burger  = document.getElementById('bt-burger');
  const overlay = document.getElementById('bt-nav-overlay');
  const burgerIcon = document.getElementById('bt-burger-icon');

  if (burger && overlay) {
    let isOpen = false;

    const openMenu = () => {
      isOpen = true;
      overlay.classList.remove('is-closing');
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      if (burgerIcon) { burgerIcon.className = 'fa-solid fa-xmark'; }
      document.body.style.overflow = 'hidden';
    };

    const closeMenu = () => {
      isOpen = false;
      overlay.classList.remove('is-open');
      overlay.classList.add('is-closing');
      burger.setAttribute('aria-expanded', 'false');
      if (burgerIcon) { burgerIcon.className = 'fa-solid fa-bars'; }
      document.body.style.overflow = '';
      overlay.addEventListener('animationend', () => {
        overlay.classList.remove('is-closing');
        overlay.setAttribute('aria-hidden', 'true');
      }, { once: true });
    };

    burger.addEventListener('click', () => isOpen ? closeMenu() : openMenu());

    // Close on overlay link click
    overlay.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
  }

  // ── PROCESS: scroll-based step highlight (mobile) ─────────
  const processOuter = document.querySelector('.bt-process-outer');
  const processSteps = document.querySelectorAll('.bt-process-step');
  const processSegs  = document.querySelectorAll('.bt-process-bar-seg');

  if (processOuter && processSteps.length && window.innerWidth < 768) {
    const setStep = (idx) => {
      processSteps.forEach((s, i) => s.classList.toggle('active', i === idx));
      processSegs.forEach((s, i) => s.classList.toggle('active', i === idx));
    };

    // Use IntersectionObserver on each step
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const idx = parseInt(e.target.dataset.step);
          if (!isNaN(idx)) setStep(idx);
        }
      });
    }, { threshold: 0.5 });

    processSteps.forEach(s => observer.observe(s));
  }

  // ── WHY US: carousel nav buttons ─────────────────────────
  const carousel = document.getElementById('bt-whyus-carousel');
  const prevBtn  = document.getElementById('bt-whyus-prev');
  const nextBtn  = document.getElementById('bt-whyus-next');

  if (carousel && prevBtn && nextBtn) {
    const CARD_W = 240 + 16; // width + gap
    prevBtn.addEventListener('click', () => { carousel.scrollBy({ left: -CARD_W, behavior: 'smooth' }); });
    nextBtn.addEventListener('click', () => { carousel.scrollBy({ left:  CARD_W, behavior: 'smooth' }); });
  }

  // ── PRICES: tab switcher ──────────────────────────────────
  const priceTabs   = document.querySelectorAll('.bt-prices-tab');
  const pricePanels = document.querySelectorAll('.bt-prices-panel');

  priceTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      priceTabs.forEach(t => { t.classList.toggle('active', t === tab); t.setAttribute('aria-selected', t === tab); });
      pricePanels.forEach(p => p.classList.toggle('active', p.id === `panel-${target}`));
    });
  });

  // ── FAQ: accordion ────────────────────────────────────────
  document.querySelectorAll('.bt-faq-item-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const answer = btn.nextElementSibling;
      const icon   = btn.querySelector('.bt-faq-item-icon');
      const isOpen = answer.classList.contains('open');

      answer.classList.toggle('open', !isOpen);
      icon.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  // ── PRODUCT GALLERY: carrusel automático + thumbnails ─────
  const galleryEl = document.getElementById('bt-gallery-carousel');
  if (galleryEl) {
    const slides = galleryEl.querySelectorAll('.bt-gallery-slide');
    const thumbs = document.querySelectorAll('.bt-product-gallery__thumb');
    let current = 0;
    let timer = null;

    const goTo = (i) => {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('active', idx === current));
      thumbs.forEach((t, idx) => t.classList.toggle('active', idx === current));
    };
    const startAuto = () => {
      if (timer) clearInterval(timer);
      if (slides.length > 1) timer = setInterval(() => goTo(current + 1), 4000);
    };

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        goTo(parseInt(thumb.dataset.slide, 10));
        startAuto(); // reinicia el contador tras interacción manual
      });
    });
    startAuto();
  }

  // ── ADD TO CART (página de producto + price cards) ────────
  // Un solo precio, un solo bote y UN SOLO producto por pedido (una receta
  // por pedido): el carrito se reemplaza en vez de acumular, y se descarta
  // la receta anterior si la había (era de otro producto).
  const addToCart = async (variantId, btn) => {
    if (!variantId) return;
    const original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Añadiendo…';
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { receta_status: null, receta_id: null, receta_archivo: null } })
      });
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });
      if (!res.ok) throw new Error();
      window.location.href = '/cart';
    } catch {
      btn.disabled = false;
      btn.innerHTML = original;
    }
  };

  const addBtn = document.getElementById('add-to-cart-btn');
  if (addBtn) addBtn.addEventListener('click', () => addToCart(addBtn.dataset.variantId, addBtn));

  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', () => addToCart(btn.dataset.addToCart, btn));
  });

  // ── CART: prescription upload ─────────────────────────────
  const uploadZone   = document.getElementById('upload-zone');
  const fileInput    = document.getElementById('receta-input');
  const statusEl     = document.getElementById('validation-status');
  const checkoutBtn  = document.getElementById('checkout-btn');
  const VALIDATOR_URL = 'https://recetas.boticat.mx/validar';

  if (uploadZone && fileInput) {
    uploadZone.addEventListener('click', () => fileInput.click());
    uploadZone.addEventListener('dragover', e => { e.preventDefault(); uploadZone.classList.add('drag-over'); });
    uploadZone.addEventListener('dragleave', () => uploadZone.classList.remove('drag-over'));
    uploadZone.addEventListener('drop', e => {
      e.preventDefault();
      uploadZone.classList.remove('drag-over');
      const file = e.dataTransfer.files[0];
      if (file) handleFile(file);
    });
    fileInput.addEventListener('change', () => { if (fileInput.files[0]) handleFile(fileInput.files[0]); });

    async function handleFile(file) {
      if (!['application/pdf','image/jpeg','image/png'].includes(file.type)) {
        showStatus('error', 'Formato no válido. Sube un PDF, JPG o PNG.');
        return;
      }
      uploadZone.querySelector('.bt-upload-zone__title').textContent = file.name;
      showStatus('pending', 'Validando receta…');
      if (checkoutBtn) checkoutBtn.disabled = true;

      const formData = new FormData();
      formData.append('file', file);
      formData.append('cart_token', document.cookie.match(/cart=([^;]+)/)?.[1] || '');

      try {
        const res  = await fetch(VALIDATOR_URL, { method: 'POST', body: formData });
        const data = await res.json();
        if (data.valid) {
          showStatus('success', '✓ Receta válida. Ya puedes continuar con tu pedido.');
          if (checkoutBtn) checkoutBtn.disabled = false;
        } else {
          showStatus('error', `Receta no válida: ${data.message || 'Verifica los datos e intenta de nuevo.'}`);
        }
      } catch {
        // If validator is down, allow checkout with file attached
        showStatus('success', 'Receta adjuntada. La validaremos al procesar tu pedido.');
        if (checkoutBtn) checkoutBtn.disabled = false;
      }
    }

    function showStatus(type, msg) {
      if (!statusEl) return;
      statusEl.className = `bt-validation-status ${type}`;
      statusEl.textContent = msg;
    }
  }

});
